import {Component, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';

import {ItemsService} from './items.service';
import {Col} from '../../../../shared/model';
import {AuthService} from '../../../../shared/service/auth.service';
import {LazyLoadEvent} from 'primeng-lts/api';

@Component({
  selector: 'app-consume-review',
  templateUrl: './consume-review.component.html'
})
export class ConsumeReviewComponent implements OnInit {
  items: Array<any> = new Array<any>();
  totalRecords: number = 0;

  cols: Array<Col> = [
    {width: 80, fixedWidth: true, field: 'requestTypeEnum', header: 'Loại yêu cầu', type: 'text', matchMode: 'contains', format: 'text', visible: true},
    {width: 80, fixedWidth: true, field: 'productPseudoId', header: 'Mã gói', type: 'text', matchMode: 'contains', format: 'text', visible: true},
    {width: 180, fixedWidth: true, field: 'itemDescription', header: 'Tên gói', type: 'text', matchMode: 'contains', format: 'text', visible: true},
    {width: 80, fixedWidth: true, field: 'requestDate', header: 'Ngày yêu cầu', type: '', matchMode: 'contains', format: 'date', visible: true},
    {width: 200, fixedWidth: true, field: 'filedByParty', header: 'Người yêu cầu', type: 'text', matchMode: 'contains', format: 'text', visible: true},
    {width: 100, fixedWidth: true, field: 'status', header: 'Trạng thái', type: 'text', matchMode: 'contains', format: 'text', visible: true},
    {width: 80, fixedWidth: true, field: 'usedQuantity', header: 'Đã sử dụng', type: 'text', matchMode: 'contains', format: 'text', visible: true},
    {width: 80, fixedWidth: true, field: 'quantityOnHandTotal', header: 'Còn lại', type: 'text', matchMode: 'contains', format: 'text', visible: true},
    {width: 80, fixedWidth: true, field: 'receivedDate', header: 'Ngày hiệu lực', type: '', matchMode: 'contains', format: 'date', visible: true},
    {width: 80, fixedWidth: true, field: 'activationValidThru', header: 'Ngày hết hạn', type: '', matchMode: 'contains', format: 'date', visible: true},
    {width: 140, fixedWidth: true, field: 'description', header: 'Ghi chú', type: 'text', matchMode: 'contains', format: 'text', visible: true},

  ];

  constructor(
    private fb: FormBuilder,
    private itemsService: ItemsService
  ) {
  }

  ngOnInit(): void {
    this.loadLazy({first: 0, rows: 10, filters: {}});
  }

  loadLazy(event: LazyLoadEvent): void {
    this.itemsService.getRequestList(JSON.stringify(event), {excludeProductCategoryId: 'IamSyncInvoice'}).subscribe((response) => {
      this.totalRecords = response?.totalRecords;
      this.items = response?.listData;
    });
  }
}
